// packages/shared-hooks/src/lead-tasks/useCancelLeadTask.ts
//
// `PATCH /lead-tasks/:id/cancel` (#2317 D-3) — soft-cancel an OWN open MANUAL
// task. Backend returns 204 and writes a `LEAD_TASK_CANCELLED` audit row in
// the same tx. Success flushes the whole `lead-tasks` prefix (the row leaves
// the open list and joins the per-lead cancelled list) and the lead activity
// feed prefix (covers the default + `feedV2` opt-in slots) so the card's
// opted-in timeline picks up the audit row.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from '../lead-activity/keys.js';
import { leadTasksKeys } from './keys.js';

export function useCancelLeadTask(id: string, leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => client.patch<void>(`/lead-tasks/${id}/cancel`, undefined, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadTasksKeys.all });
      void qc.invalidateQueries({ queryKey: leadActivityKeys.feed(leadId) });
    },
  });
}
